import { render, staticRenderFns } from "./getExpiration.vue?vue&type=template&id=035b6d44&"
import script from "./getExpiration.vue?vue&type=script&lang=js&"
export * from "./getExpiration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports